export const BOOKING_TIMEZONE = 'Asia/Riyadh';
export const API_BASE_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
export const OAUTH_BASE_URL = process.env.REACT_APP_API_BASE_URL ||
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:8080'
    : '');
